<template>
  <structure-list ref="invite_modal" id="invite_modal" :bauhof-structure="possibleInvites" :multi-select="false" @on-selected="onInvite" @hidden="hidden"/>
</template>

<script>
import VJstree from "vue-jstree";
import {Redirect_500, Redirect_Login, Server_URL} from "@/shared/utils";
import {encryptAES} from "@/shared/crypto";
import StructureList from "@/views/lists/StructureList.vue";

export default {
  name: "task_messaging_invite",
  props: {
    room: Object,
    showInvite: Boolean,
  },
  components: {
    VJstree,
    StructureList,
  },
  data() {
    return {
      showModal: false,
      possibleInvites: [],
      selectedInvite: null,
      loader: undefined,
      myUser: "",
    }
  },
  watch: {
    showInvite: function(newVal, oldVal) { // watch it
      if (this.showModal !== newVal) {
        if (newVal) {
          this.onShow();
          this.showModal = true;
        } else {
          this.showModal = newVal;
        }
      }
    }
  },
  mounted() {
    this.myUser = this.$cookies.get("ps_user_id");
  },
  methods: {
    hidden() {
      this.$emit("hidden")
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_Login;
      }
    },
    async onInvite({ids}) {
      let room = this.room;
      let me = JSON.parse(sessionStorage.getItem(this.$cookies.get("ps_user_id")));
      let them = JSON.parse(sessionStorage.getItem(ids[0]));
      let messagePlain = me.full_name + " hat " + them.full_name + " hinzugefügt."
      let encryptedContent = await encryptAES(sessionStorage.getItem("aes"), messagePlain);

      let req = {
        user_name: me.full_name,
        room_id: room.roomId,
        data_id: room.roomId,
        user_id: ids[0],
        invite_message: encryptedContent,
        invite_message_plain: messagePlain,
      }
      let response;
      try {
        response = await this.$http.post(
            Server_URL + '/auftragsbuch/messaging/room/invite', req
        )
      } catch (e) {
        this.responseError(e)
        return
      }
      if (response.status !== 200) {
        window.location = Redirect_500;
        return
      }
      this.$emit("invite-success", this.selectedInvite.id)
    },
    async onShow() {
      let response;
      this.showLoader();
      try {
        response = await this.$http.get(
            Server_URL + '/auftragsbuch/messaging/room/invites/'+this.room.roomId
        )
      } catch (e) {
        this.hideLoader();
        this.responseError(e)
        return
      }
      this.hideLoader();
      let data = response.body;
      let selection = [];
      for (let i = 0; i < data.length; i++) {
        let cur = data[i];
        let found = this.isInRoom(this.room, cur);
        if (!found) {
          let res = JSON.parse(sessionStorage.getItem(cur));
          if (res) {
            selection.push({
              id: cur,
              text: res.full_name,
              node_type: "user",
              icon: "icon-none",
              disabled: false,
              selected: false,
            })
          }
        }
      }
      selection.sort((a,b) => (a.text > b.text) ? 1 : ((b.text > a.text) ? -1 : 0))
      this.selectedInvite = null;
      this.possibleInvites = selection;
      this.$refs.invite_modal.showModal();
    },
    onInviteItemClicked(node, item, e) {
      this.selectedInvite = item;
    },
    isInRoom(room, userId) {
      let found = false;
      for (let j = 0; j < room.users.length; j++) {
        if (userId === room.users[j]._id || userId === this.myUser) {
          found = true;
          break
        }
      }
      return found;
    },
    showLoader() {
      this.hideLoader();
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
  },
  computed: {
    roomUsers() {
      let res = [];
      if (!this.users || !this.users.length) {
        return res;
      }
      for (let i = 0; i < this.users.length; i++) {
        let parsed = JSON.parse(sessionStorage.getItem(this.users[i]._id))
        res.push(parsed.full_name);
      }
      //sort the room users
      res.sort((a, b) => {
        const nameA = a.toUpperCase(); // ignore upper and lowercase
        const nameB = b.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }
        // names must be equal
        return 0;
      });
      return res;
    }
  },
}
</script>

<style scoped>

</style>
